var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1320_220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.683594,
    width: 24,
    height: 24,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1320_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2839 11.9694H19.0396C18.6523 10.4477 17.1046 9.52816 15.5829 9.91549C14.5738 10.1726 13.7861 10.9603 13.529 11.9694H2.71446C2.32061 11.9694 2 12.2884 2 12.6838C2 13.0793 2.31899 13.3983 2.71446 13.3983H13.529C13.9163 14.92 15.4641 15.8395 16.9858 15.4522C17.9948 15.195 18.7825 14.4073 19.0396 13.3983H21.2839C21.6778 13.3983 21.9984 13.0793 21.9984 12.6838C21.9984 12.2884 21.6794 11.9694 21.2839 11.9694ZM16.2843 14.1128C15.495 14.1128 14.8554 13.4731 14.8554 12.6838C14.8554 11.8945 15.495 11.2549 16.2843 11.2549C17.0736 11.2549 17.7132 11.8945 17.7132 12.6838C17.7132 13.4731 17.0736 14.1128 16.2843 14.1128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71609 6.96978H4.96036C5.3477 8.49146 6.89542 9.41098 8.41711 9.02364C9.42614 8.7665 10.2138 7.97881 10.471 6.96978H21.2855C21.6794 6.96978 22 6.65079 22 6.25531C22 5.85984 21.681 5.54085 21.2855 5.54085H10.471C10.0836 4.01916 8.53592 3.09964 7.01423 3.48698C6.0052 3.74412 5.2175 4.53182 4.96036 5.54085H2.71609C2.32224 5.54085 2.00163 5.85984 2.00163 6.25531C2.00163 6.65079 2.32062 6.96978 2.71609 6.96978ZM7.71405 4.82802C8.50337 4.82802 9.14298 5.46762 9.14298 6.25694C9.14298 7.04627 8.50337 7.68587 7.71405 7.68587C6.92473 7.68587 6.28513 7.04627 6.28513 6.25694C6.28513 5.46762 6.92473 4.82802 7.71405 4.82802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2839 18.3979H12.6127C12.2254 16.8762 10.6777 15.9567 9.15599 16.344C8.14696 16.6011 7.35926 17.3888 7.10212 18.3979H2.71609C2.32224 18.3979 2.00163 18.7169 2.00163 19.1123C2.00163 19.5078 2.32062 19.8268 2.71609 19.8268H7.10212C7.48946 21.3485 9.03718 22.268 10.5589 21.8807C11.5679 21.6235 12.3556 20.8358 12.6127 19.8268H21.2839C21.6778 19.8268 21.9984 19.5078 21.9984 19.1123C21.9984 18.7169 21.6794 18.3979 21.2839 18.3979ZM9.85744 20.5396C9.06811 20.5396 8.42851 19.9 8.42851 19.1107C8.42851 18.3214 9.06811 17.6818 9.85744 17.6818C10.6468 17.6818 11.2863 18.3214 11.2863 19.1107C11.2863 19.9 10.6468 20.5396 9.85744 20.5396Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.0cc577dca97be094bbd3749348b853b7.svg";
export { ForwardRef as ReactComponent };